import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "b1fde378-f038-46ce-896e-47deb5a6548b";
const statusLookup = [
    { ID: 'O', Text: "Open" },
    { ID: 'H', Text: "Hold" },
    { ID: 'L', Text: "Ready To Commit Later" },
    { ID: 'N', Text: "Ready To Commit Now" },
  ];
  const toStage = [
    { ID: 'L', Text: 'Canceled - No Inventory Effect' },
    { ID: 'Q', Text: 'Quote - No Inventory Effect' },
    { ID: 'P', Text: 'Plan - No Inventory Effect' },
    { ID: 'F', Text: 'Future - No Effect on Net Available' },
    { ID: 'N', Text: 'Pending - Effects Net Available' },
    { ID: 'A', Text: 'Assigned - Effects Available' },
    { ID: 'S', Text: 'Picked/Staged - Effects Available' },
    { ID: 'C', Text: 'Shipped/Completed - Effects Available' }
  ];
class TransactionsGridPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }
    
    loadState() {
       // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
      }
    
      saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
      }
    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    // The DevExtreme OPTION, not just the style rule below: the widget has to know its
                    // own height to size the virtual scroller, and a CSS height:100% it cannot read
                    // leaves it laying out against its content instead of its container. Undefined
                    // unless the host passes one, so existing callers keep the height they had.
                    height={this.props.height}
                    style={{ height: '100%', width: '100%' }}
                //onContentReady={this.DetailInGridContentReady}
                >
                    <Scrolling mode="virtual" useNative={false} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />

                    <Column
                        dataField="recordNo"
                        caption="Record #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="customerID"
                        caption="Customer"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="transactionnumber"
                        caption="Transaction #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="transactiondate"
                        caption="Transaction Date"
                        dataType="date"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="shipToID"
                        caption="Ship To"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="shipViaID"
                        caption="Ship Via"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="shippingdate"
                        caption="Shipping Date"
                        dataType="date"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="purchaseordernumber"
                        caption="PO Number"
                        allowEditing={false}

                    ></Column>
                    <Column
                        dataField="Truckreference"
                        caption="Reference #"
                        allowEditing={false}

                    ></Column>
                    <Column
                        dataField="equipment"
                        caption="Equipment"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="invoicedate"
                        caption="Invoice Date"
                        dataType="date"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="transactionduedate"
                        caption="Transaction due date"
                        dataType="date"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="discounttype"
                        caption="Discount type"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="ordersignedflag"
                        caption="Order Signed"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="Truckreference"
                        caption="Truck Reference"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="truckdepartdatetime"
                        caption="Truck Depart Datetime"
                        dataType="date"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="truckarrivaldatetime"
                        caption="Truck Arrival Datetime"
                        dataType="date"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="printinvoice"
                        caption="Print invoice"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="printbol"
                        caption="Print bol"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="printdeliverynotification"
                        caption="Print delivery notification"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="printorderacknowledgement"
                        caption="Print order acknowledgement"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="sendfax"
                        caption="Send Fax"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="sendemail"
                        caption="Send Email"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="canceldate"
                        caption="Cancel Date"
                        dataType="date"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="inventotyavailabilitystatus"
                        caption="inventory Availability Status"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                      <Column
                        dataField="stage"
                        caption="Stage"
                        allowEditing={false}
                        visible={false}
                        lookup={{ dataSource: toStage, valueExpr: 'ID', displayExpr: 'Text' }}
                        cellRender={cellData => {
                          switch (cellData.value) {
                            case 'L':
                              return <span >Canceled - No Inventory Effect</span>;
                            case 'Q':
                              return <span >Quote - No Inventory Effect</span>;
                            case 'P':
                              return <span >Plan - No Inventory Effect</span>;
                            case 'F':
                              return <span >Future - No Effect on Net Available</span>;
                            case 'N':
                                return <span >Pending - Effects Net Available</span>;
                            case 'S':
                                return <span >Picked/Staged - Effects Available</span>;
                            case 'C':
                                 return <span >Shipped/Completed - Effects Available</span>;
                            case 'A':
                                return <span >Assigned - Effects Available</span>;
                                                            
                              default:
                              return <span>{cellData.value}</span>;
                          }
                        }}
                    ></Column>
                      <Column
                        dataField="status"
                        caption="Status"
                        allowEditing={false}
                        visible={false}
                        lookup={{ dataSource: statusLookup, valueExpr: 'ID', displayExpr: 'Text' }}
                        cellRender={cellData => {
                          switch (cellData.value) {
                            case 'O':
                              return <span >Open</span>;
                            case 'H':
                              return <span >Hold</span>;
                            case 'L':
                              return <span >Ready To Commit Later</span>;
                            case 'N':
                              return <span >Ready To Commit Now</span>;
                            default:
                              return <span>{cellData.value}</span>;
                          }
                        }}
                    
                    ></Column>
                    <Column
                        dataField="discountpercent"
                        caption="Discount %"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="partialshipment"
                        caption="Partial Shipment"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="creditreviewdate"
                        caption="Credit Review Date"
                        dataType="date"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="salesmethod"
                        caption="Sales Method"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="fiscalperiod"
                        caption="FP"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="fiscalyear"
                        caption="FY"
                        allowEditing={false}
                        visible={false}
                    ></Column>

                    <Column
                        dataField="profileCode"
                        caption="Profile Code"
                        allowEditing={false}
                        visible={false}

                    ></Column>

                    <Column
                        dataField="customerIDGroup"
                        caption="Customer ID Group"
                        allowEditing={false}
                        visible={false}

                    ></Column>

                    <Column
                        dataField="customerIDSubgroup"
                        caption="Customer ID Sub Group"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode1"
                        caption="Customer Code 1"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode2"
                        caption="Customer Code 2"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode3"
                        caption="Customer Code 3"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode4"
                        caption="Customer Code 4"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode5"
                        caption="Customer Code 5"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode6"
                        caption="Customer Code 6"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode7"
                        caption="Customer Code 7"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode8"
                        caption="Customer Code 8"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode9"
                        caption="Customer Code 9"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="customercode10"
                        caption="Customer Code 10"
                        allowEditing={false}
                        visible={false}

                    ></Column>
                    <Column
                        dataField="shipperID"
                        caption="Shipper ID"
                        allowEditing={false}
                        visible={false}
                    ></Column>

                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(TransactionsGridPreview);